/**
 * Visible "Last updated" stamp for service pages and other content pages.
 * Helps Google and AI crawlers assess freshness; matches the date pattern
 * already used in ArticleLayout for blog posts.
 */
type Props = {
  /** ISO date string, e.g. "2026-04-28" */
  date: string;
  className?: string;
};

function formatLongDate(iso: string) {
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function LastUpdated(_props: Props) {
  // Visible stamp intentionally hidden site-wide. Freshness signals are still
  // emitted via sitemap `lastmod` and JSON-LD `dateModified` in page heads.
  return null;
}

// Keep helper exported-shape stable; suppress unused warning.
void formatLongDate;
